<!-- Show Credit Balance Modal -->
<p-dialog [visible]="visible()" (onHide)="closeDialog()" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '660px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">


    <!-- Header -->
    <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
      <h2 class="mb-0 text-sm">{{'REFUND.CREDIT_BALANCE' | translate }}</h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeCreditPopup(false)"></div>
    </div>
    <!-- Header -->

    <!-- Table -->
    <p-table [value]="clientCreditBalance$ | async" styleClass="" responsiveLayout="scroll" [loading]="loadTable">
      <ng-template pTemplate="header">
        <tr class="text-xs font-bold">
          <th class="text-600 surface-300 py-2 white-space-nowrap">{{'REFUND.TENANT' | translate }}</th>
          <th class="text-600 surface-300 py-2 white-space-nowrap">{{'REFUND.AMOUNT' | translate }}</th>
          <th class="text-600 surface-300 py-2 white-space-nowrap"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-creditBalanceData>
        <tr class="text-sm">
          <td class="py-2 border-bottom-1 border-300 white-space-nowrap">{{ getTenant(creditBalanceData.tenant_id).name_primary_language}}</td>
          <td class="py-2 border-bottom-1 border-300 white-space-nowrap">{{ creditBalanceData.available_credit_balance | currencyformat }}</td>
          <td class="py-2 border-bottom-1 border-300 white-space-nowrap">
            @if (creditBalanceData.available_credit_balance > 0) {
              <p-button icon="fa fa-angle-down" [label]="'common.LABELS.ACTION' | translate" iconPos="right" styleClass="surface-0 p-button-outlined border-300 ml-2 text-600 text-sm"
              (click)="creditBalanceAction.toggle($event)"  />
            }
            <p-popover #creditBalanceAction styleClass="overflow-hidden right-0 text-sm w-9rem">
              <ng-template #content>
                <ul class="list-none -m-4 px-0 py-2 text-xs text-600">
                  <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"  [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
                    (click)="ProcessRefund(creditBalanceData)"><i
                  class="fa fa-rotate-left text-500 mr-2"></i>{{ 'ADMIN.COMMON.REFUND' | translate }}</li>
                </ul>
              </ng-template>
            </p-popover>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- Table -->


  </ng-template>

</p-dialog>
<!-- Show Credit Balance Modal -->

@if ((showRefund | async); as showPopup) {
  <fitness-force-process-refund [visible]="showPopup" (onHide)="closeDialog()" [IsMinimumPaymentRequired]="false"
    [refundData]="refundData" (closeDialog)="closeRefundDialogEvent($event)" />
}

